module.exports = __webpack_public_path__ + "static/media/esp.3f8709e6.svg";